module.exports = __webpack_public_path__ + "static/media/expand-professional-network-online.e43a7d3c.png";